import styled from 'styled-components';
import { CloseCircleOutlined, DownOutlined } from '@ant-design/icons';

export const ClearIcon = styled(CloseCircleOutlined)`
  &:hover {
    color: ${({ theme }) => theme.red};
  }
`;

export const SuffixIcon = styled(DownOutlined).attrs({
  className: 'ant-select-suffix',
})``;
